import { createContext, type ReactNode, useCallback, useContext, useMemo, useState } from "react";

const STORAGE_KEY = "wcp-active-business";

interface BusinessCtx {
  activeId: string;
  setActiveId: (id: string) => void;
}
const Ctx = createContext<BusinessCtx | null>(null);

function readInitial(): string {
  if (typeof localStorage === "undefined") return "pisau";
  return localStorage.getItem(STORAGE_KEY) ?? "pisau";
}

export function BusinessProvider({ children }: { children: ReactNode }) {
  const [activeId, setActiveIdState] = useState<string>(readInitial);

  const setActiveId = useCallback((id: string) => {
    setActiveIdState(id);
    try {
      localStorage.setItem(STORAGE_KEY, id);
    } catch {
      /* private mode */
    }
  }, []);

  const value = useMemo(() => ({ activeId, setActiveId }), [activeId, setActiveId]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useBusiness(): BusinessCtx {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useBusiness outside BusinessProvider");
  return ctx;
}
